import { Tabs } from '@scale/scaleui';
import { useEffect } from 'react';
import { Route, useHistory, useLocation } from 'react-router-dom';
import { PermissionsManagement } from 'react-scale/components/ExpertManagement/AdminPage/PermissionsManagement';
import { PodTypeManagement } from 'react-scale/components/ExpertManagement/AdminPage/PodTypeManagement';
import { System } from 'react-scale/components/ExpertManagement/AdminPage/System';
import { AdminRoutes } from 'react-scale/components/ExpertManagement/urls';

export const AdminPageContent: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const handleTabChange = (tabId: string) => {
    history.push(tabId);
  };

  useEffect(() => {
    if (location.pathname === '/') {
      history.push(AdminRoutes.Permissions);
    }
  }, [history, location.pathname]);
  return (
    <>
      <Tabs
        className="my-2"
        onChange={handleTabChange}
        tabs={[
          {
            id: AdminRoutes.Permissions,
            label: 'Permissions Management',
          },
          {
            id: AdminRoutes.PodTypeManagement,
            label: 'Pod Type Management',
          },
          {
            id: AdminRoutes.System,
            label: 'System',
          },
        ]}
        value={location.pathname}
        variant="default"
      />
      <Route path={AdminRoutes.Permissions} component={PermissionsManagement} />
      <Route path={AdminRoutes.PodTypeManagement} component={PodTypeManagement} />
      <Route path={AdminRoutes.System} component={System} />
    </>
  );
};
